import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { FormatterService, pattern } from '@xmedical/core';

@Component({
    selector: 'xui-mat-text-display',
    templateUrl: './app-mat-text-display.component.html',
    styleUrls: ['./app-mat-text-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppMatTextDisplayComponent {
    private formatter = inject(FormatterService);

    readonly label = input('');
    readonly value = input<any>('');
    readonly pattern = input<pattern>('default');
    readonly formattedValue = computed(() => this.formatter.format(this.value(), this.pattern()));

    get showLabel(): boolean {
      return this.label().length > 0;
    }

    get displayValue(): string {
        const value = this.formattedValue();
        return (value && value.length) ? value : 'Not specified';
    }
}
